import {http_client} from "@/plugins/http_client";

const url = '/api/v1/solicitud-contratacion/cifrados'
const planilla_URL = `${process.env.VUE_APP_URL_API_PLANILLA}`

const getCifrados = async (params = {}) => await http_client(`${url}`, {}, 'get')
const getRubro = async (id_cifrado) => {
  return await http_client(`${planilla_URL}/api/v1/presupuesto/anual/establecimientos/cifrados/especificos-gastos/contratacion/${id_cifrado}`, {}, 'get')
}
const getCuentas = async (id_especifico_gasto) => {
  return await http_client(`${planilla_URL}/api/v1/presupuesto/anual/establecimientos/cifrados/especificos-gastos/contratacion/padre/${id_especifico_gasto}`, {}, 'get')
}
const getEspecificos = async (id_cuenta) => {
  return await http_client(`${planilla_URL}/api/v1/presupuesto/anual/establecimientos/cifrados/especificos-gastos/contratacion/padre/${id_cuenta}`, {}, 'get')
}

export default {
  getCifrados,
  getRubro,
  getCuentas,
  getEspecificos
}